import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/Link';
import s from './Highlights.scss';

const Highlights = props => {
  const { data } = props;
  const { gaCategory } = props;
  const getHeadingText = () => {
    let heading = 'Key Event';
    if (data instanceof Array && data.length > 1) {
      heading += 's';
    }
    return heading;
  };
  return (
    <div className={s.keyhighlights}>
      <h4>{getHeadingText()}</h4>
      <ul className={s.item}>
        {data instanceof Array &&
          data.map(item => (
            <li className={`${item.overridelink ? s.link : ''}`}>
              {item.overridelink ? (
                <Link
                  to={item.overridelink}
                  data-newga={`click#keyEvents_${item.overridelink}${
                    gaCategory ? `#${gaCategory}` : ''
                  }`}
                  target="_blank"
                >
                  <span className={s.list_items}>{item.title}</span>
                </Link>
              ) : (
                <span className={s.list_items}>{item.title}</span>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

Highlights.propTypes = {
  data: PropTypes.shape({}),
};

Highlights.defaultProps = {
  data: '',
};
export default Highlights;
